import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-modal-previsualizar-game',
  templateUrl: './modal-previsualizar-game.component.html',
  styleUrls: ['./modal-previsualizar-game.component.css']
})
export class ModalPrevisualizarGameComponent implements OnInit, OnChanges {
  @Output() saveButton = new EventEmitter<Object>();
  @Input() url:string;

  constructor() { }

  ngOnInit(): void {
  }

  close() {
    this.saveButton.emit({
      type: "close",
      value: ""
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    setTimeout(() => {
      this.ChangeIframe();
    }, 800);
    
  }

  ChangeIframe(){
    document.getElementById('ifrmPrevisualizar')["src"] = this.url;
  }

}
